import { ExecutionJobStatus } from "../../types/ExecutionStatus.ts";

const executionJobStatusChipStyles = {
  jobStatusChipSxByStatus: {
    pendingApproval: { backgroundColor: "primary.light", color: "primary.contrastText" },
    approved: { backgroundColor: "success.light", color: "success.contrastText" },
    running: { backgroundColor: "info.light", color: "info.contrastText" },
    completed: { backgroundColor: "warning.light", color: "warning.contrastText" },
    failed: { backgroundColor: "error.light", color: "error.contrastText" },
    partiallyFailed: { backgroundColor: "grey.200", color: "text.primary" },
    rejected: { backgroundColor: "grey.300", color: "text.primary" },
  } satisfies Record<ExecutionJobStatus, Record<string, string>>,
};

export default executionJobStatusChipStyles;
